export type { HocuspocusProvider as TiptapCollabProvider } from "@hocuspocus/provider";
export { TiptapTransformer } from "@hocuspocus/transformer";
export { mergeAttributes } from "@tiptap/core";
export type { Editor, JSONContent } from "@tiptap/core";
export { Heading } from "@tiptap/extension-heading";
export { generateJSON } from "@tiptap/html";
export * from "@tiptap/static-renderer";
export { renderToHTMLString } from "@tiptap/static-renderer";
export {
  extensions,
  extensionsRich,
  extensionsStoryComment,
} from "./components/extensions";
export { extractTipTapJSON } from "./lib/extract-tiptap-json";
